import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import {
	ButtonGroupLayout,
	ContentLayout,
	DataTable,
	LayoutGap,
} from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';
import { CmsPageSkeleton } from '../../../Cms/CmsPageSkeleton';

export const RezaDetailSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);

	return (
		<CmsPageSkeleton>
			<LayoutGap>
				<ContentLayout>
					<LayoutGap gap="m">
						<GovSkeleton
							width="220px"
							height="26px"
							aria-label={t('loading.wcag.processing')}
						/>
						<DataTable responsive>
							<tbody>
								{Array.from(Array(7))
									.fill(null)
									.map((_, index) => (
										// eslint-disable-next-line react/no-array-index-key
										<tr key={index}>
											<td className="sm:w-1/2!">
												<GovSkeleton
													width={generateRandomNumber(20, 70) + '%'}
													height="20px"
													aria-label={t('loading.wcag.processing')}
												/>
											</td>
											<td>
												<GovSkeleton
													width={generateRandomNumber(20, 70) + '%'}
													height="20px"
													aria-label={t('loading.wcag.processing')}
													className="flex grow"
												/>
											</td>
										</tr>
									))}
							</tbody>
						</DataTable>
						<ButtonGroupLayout>
							<GovSkeleton
								width="160px"
								height="38px"
								aria-label={t('loading.wcag.processing')}
							/>
							<GovSkeleton
								width="180px"
								height="38px"
								aria-label={t('loading.wcag.processing')}
							/>
						</ButtonGroupLayout>
					</LayoutGap>
				</ContentLayout>
			</LayoutGap>
		</CmsPageSkeleton>
	);
};
